import axios from 'axios'

export const AdminTownshipService = {
  fetchTownshipList (status) {
    let queryParams = '?'
    if (status !== undefined && status !== '') {
      queryParams += `status=${status}&`
    }
    return axios.get(`/api/v1/townshiplist${queryParams}`)
  },
  // get township list
  fetchTownshipByStateAndCounty (countryId, stateId, countyId, fetchOnlyPublished) {
    let queryParams = '?'
    if (countryId !== undefined && countryId !== '') {
      queryParams += `cId=${countryId}&`
    }
    if (stateId !== undefined && stateId !== '') {
      queryParams += `sId=${stateId}&`
    }
    if (countyId !== undefined && countyId !== '') {
      queryParams += `cntId=${countyId}&`
    }
    if (fetchOnlyPublished !== undefined && fetchOnlyPublished !== '') {
      queryParams += `status=${fetchOnlyPublished}&`
    }
    return axios.get(`/public/api/v1/townshiplist${queryParams}`)
  },
  fetchPaginatedTownshipList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/gettownshiplist${queryParams}`)
    } else {
      return axios.get(`/api/v1/gettownshiplist`)
    }
  },
  fetchFIPSList () {
    return axios.get(`/api/v1/townshipfips`)
  },
  fetchFilteredTownshipList (countryId, stateId, countyId, status) {
    let queryParams = '?'
    if (countryId !== undefined && countryId !== '') {
      queryParams += `cId=${countryId}&`
    }
    if (stateId !== undefined && stateId !== '') {
      queryParams += `sId=${stateId}&`
    }
    if (countyId !== undefined && countyId !== '' && countyId !== null) {
      queryParams += `cntId=${countyId}&`
    }
    if (status !== undefined && status !== '') {
      queryParams += `status=${status}&`
    }
    return axios.get(`/api/v1/townshiplist${queryParams}`)
  },
  addTownshipItem (data) {
    return axios.post(`/api/v1/addtownship`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  },
  editTownshipItem (data) {
    return axios.post(`/api/v1/edittownship`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  },
  fetchTownshipPostalCode (id) {
    if (id !== undefined && id !== null && id !== '') {
      return axios.get(`/api/v1/gettownshippostalcode/${id}`)
    } else {
      return axios.get(`/api/v1/gettownshippostalcode`)
    }
  },
  getTownshipDetailsById (id) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `jId=${id}&`
    }
    return axios.get(`/api/v1/township${queryParams}`)
  },
  // validate township
  validateTownshipItem (Data) {
    return axios.delete(`/api/v1/deletetownship`, { data: Data })
  },
  // delete township item
  deleteTownshipItem (Data) {
    return axios.delete('/api/v1/deletetownship', { data: Data })
  }
}
